import { render, staticRenderFns } from "./integral_edit.vue?vue&type=template&id=99598184&scoped=true&"
import script from "./integral_edit.vue?vue&type=script&lang=js&"
export * from "./integral_edit.vue?vue&type=script&lang=js&"
import style0 from "./integral_edit.vue?vue&type=style&index=0&id=99598184&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99598184",
  null
  
)

export default component.exports